import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "collect-buy-tip-content" }
const _hoisted_2 = { class: "collect-buy-head rel" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/buy_head.png",
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "collect-buy-tip-product" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "scroll-content" }
const _hoisted_7 = { class: "product-info" }
const _hoisted_8 = { class: "product-name line--2" }
const _hoisted_9 = { class: "product-price flex-ter-bwn" }
const _hoisted_10 = { class: "price" }
const _hoisted_11 = { class: "buy-btn" }

import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { isJA, useRtfix } from '@/store'
import { wishListTipApi } from '@/apis/user'
import { useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { calcCeil } from '@/util/useYan'
import { updateWishlistReadStatusApi } from '@/apis/goods'
import Image from '@/components/common/Image.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const visible = ref(false)
const productList: any = ref([])
onMounted(async () => {
  const isLoginNow = localStorage.getItem('isLoginNow')
  if (isLoginNow === '1') {
    const { data }: any = await wishListTipApi()
    productList.value = data
    if (productList.value.length > 0) {
      visible.value = true
      updateWishlistReadStatusApi({
        productCodes: productList.value.map(v => v.productCode)
      })
    }
    localStorage.setItem('isLoginNow', '0')
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(CommonDialog, {
    "z-index": 3100,
    noHeader: true,
    "model-value": visible.value,
    hiddenClose: true,
    "destroy-on-close": "",
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false)),
    footer: false,
    className: "collect-buy-tip-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: "close abs",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('你的心愿单商品可以购买啦！')), 1),
          _createVNode(_component_el_scrollbar, {
            "max-height": "312px",
            always: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "collect-buy-tip-product-item flex",
                    key: i.productCode
                  }, [
                    _createVNode(Image, {
                      src: i.productMainImg,
                      alt: "",
                      class: "product-img",
                      fit: "cover"
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(i.productTitleJp || i.productTitle), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(i.productSellPrice) + " 元(" + _toDisplayString(_unref(calcCeil)(i.productSellPrice)) + " 円)", 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push(_unref(useRtfix)('CollectProduct', { query: { tab: 3, canOrder: 1 } }))))
            }, _toDisplayString(_unref(t)('去购买')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})